import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import { extractIssueButtons } from './ConstIssueBtns';
import { SUBTABS, RATE_STEPS } from './ConstPaths';
import { CLIENT_RATING_BUTTONS, SUCCESS_BUTTONS } from './ConstRatingBtns.js';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_RATE_REVIEW_HELP = `
  <div>
    <p>
    Take a minute to double-check the ratings and observations you’ve entered.  
    None of the info is absolutely required, but it provides a handy record of how this Test-drive went and lets you compare results from different Test-drives.     
    </p>
    <p>
    If you want to change anything here, use the Update button to return to that specific page.  
    </br>
    <strong>Pro tip:</strong> After you’ve made your change, use Back or the back arrow to return here. That way you don’t have to go through all the other setup pages again.   
    </p> 
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeTestDriveClientRating: PropTypes.string,
  activeTestDriveClientFeedback: PropTypes.string,
  activeTestDrivePractitionerRating: PropTypes.string,
  activeTestDriveIssuesNoted: PropTypes.arrayOf(PropTypes.string),
  activeTestDrivePractitionerComments: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeTestDriveClientRating: '',
  activeTestDriveClientFeedback: '',
  activeTestDrivePractitionerRating: '',
  activeTestDriveIssuesNoted: [],
  activeTestDrivePractitionerComments: ''
};

//content sub-component with unique content for this page
function TestDriveRateReviewContent(props) {
  const firstName = props.firstName;
  const activeTestDriveClientRating = props.activeTestDriveClientRating;
  const activeTestDriveClientFeedback = props.activeTestDriveClientFeedback;
  const activeTestDrivePractitionerRating = props.activeTestDrivePractitionerRating;
  const activeTestDriveIssuesNoted = props.activeTestDriveIssuesNoted;
  const activeTestDrivePractitionerComments = props.activeTestDrivePractitionerComments;
  
  let issueBtns = extractIssueButtons();
  const ratingBtns = CLIENT_RATING_BUTTONS;
  const successBtns = SUCCESS_BUTTONS;

  return(
    <>
    <Row>
      <Col>
      <div className="row aa-review-row border-top">
        <div className="col">
          <h5>Ratings and Observations</h5>
          <div className="col">
            <ReviewRow 
              border="none"
              padded="none"
              heading="Star Rating" 
              nextRoute={SUBTABS.RATE+"/"+RATE_STEPS.CLIENT}
              values={activeTestDriveClientRating}
              lookup={ratingBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Client Feedback" 
              nextRoute={SUBTABS.RATE+"/"+RATE_STEPS.CLIENT}
              values={activeTestDriveClientFeedback}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Success Rating" 
              nextRoute={SUBTABS.RATE+"/"+RATE_STEPS.PRACTITIONER}
              values={activeTestDrivePractitionerRating}
              lookup={successBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Practitioner Comments" 
              nextRoute={SUBTABS.RATE+"/"+RATE_STEPS.ISSUES}
              values={activeTestDrivePractitionerComments}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Issues Noted" 
              nextRoute={SUBTABS.RATE+"/"+RATE_STEPS.ISSUES}
              values={activeTestDriveIssuesNoted}
              lookup={issueBtns}
            />
          </div>
        </div>
      </div>
      </Col> 
      <Col lg={2}></Col>
    </Row>

    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveRateReview(props) {
  const firstName = props.firstName;
  const activeTestDriveClientRating = props.activeTestDriveClientRating;
  const activeTestDriveClientFeedback = props.activeTestDriveClientFeedback;
  const activeTestDrivePractitionerRating = props.activeTestDrivePractitionerRating;
  const activeTestDriveIssuesNoted = props.activeTestDriveIssuesNoted;
  const activeTestDrivePractitionerComments = props.activeTestDrivePractitionerComments;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-flag-checkered",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Review the Test-drive Summary`,
    subTitle: 'Good work! Here\'s what we\'ve got for that Test-drive:',
    learnMore: {linkText: "Learn More about Test-drive summaries",
                title: "Test-drive summaries",
                content: TD_RATE_REVIEW_HELP
                },
    nextRoute: "",
    sidebar: false
  }

  console.log("Rendering TestDriveRateReview");


  //there is no useEffect() method because we aren't saving anything here to global Sesion
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveRateReviewContent 
          firstName={firstName}
          activeTestDriveClientRating={activeTestDriveClientRating}
          activeTestDriveClientFeedback={activeTestDriveClientFeedback}
          activeTestDrivePractitionerRating={activeTestDrivePractitionerRating}
          activeTestDriveIssuesNoted={activeTestDriveIssuesNoted}
          activeTestDrivePractitionerComments={activeTestDrivePractitionerComments}
        />
      }
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveRateReview.propTypes = propTypes;
TestDriveRateReview.defaultProps = defaultProps;

export default TestDriveRateReview;